<div
  class="outer {{ animating() ? 'animating' : '' }}"
  style="--index: {{ index() }};--length: {{ renderedTexts().length }}">
  <div *ngFor="let text of renderedTexts()" class="item" (click)="this.itemClick.emit(text)">
    {{ text }}
  </div>
</div>
